// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-Lhpu","footer":"styles_footer__Qlhr2"};